import Menu from '../../components/Menu'
import * as S from './styles'

const Header = () => {
  return (
    <S.Header>
      <div className="container">
        <S.Menu>
          <a href="#">
            <img
              src="https://imovelguide.com.br/images/logo-imovel-guide.png"
              alt="Logo"
            />
          </a>
          <S.Lista>
            <li>
              <a href="#">Condomínios</a>
            </li>
            <li>
              <a href="#">Fórum</a>
            </li>
            <li>
              <a href="#">Guia</a>
            </li>
            <li>
              <a href="#">Artigos</a>
            </li>
            <li>
              <a href="#">Ferramentas</a>
            </li>
          </S.Lista>
        </S.Menu>
        <S.Menu>
          <S.Lista>
            <li>
              <a href="#">Cotar Imóvel</a>
            </li>
            <li>
              <a href="#">Planos</a>
            </li>
            <li>
              <a href="#">Entrar</a>
            </li>
          </S.Lista>
          <S.Button>Cadastrar</S.Button>
          <Menu />
        </S.Menu>
      </div>
    </S.Header>
  )
}

export default Header
